import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../utils/propUtils';
var VeltCommentsSidebarV2FilterDropdownContentListItemIndicator = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-item-indicator-v2-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2FilterDropdownContentListItemIndicator;
